import cx from 'classnames'
import {ReactNode} from 'react'

type Props = {
  children: ReactNode
  htmlFor?: string
  required?: boolean
  className?: string
}

export const Label = ({className, children, htmlFor, required = false}: Props) => {
  return (
    <div className={cx('font-medium text-[14px] leading-[140%]', className)}>
      <label htmlFor={htmlFor}>{children}</label>
      {required && <span>*</span>}
    </div>
  )
}
